import React, { useEffect } from "react";
import { useTracking } from "react-tracking";
import trackingConstants from "../constants/trackingConstants";
import { setActiveAppId } from "../redux/actions/accountActions";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import appIds from "../constants/appIdConstants";
import { IncidentProvider } from "./contexts/IncidentContext";
import RouteMapper from "../components/RouteMapper";
import { routes } from "./routes";
import { RiskAssessmentProvider } from "./contexts/RiskAssessmentContext";
import userLoginLogService from "./services/userLoginLogService";
import {useAuth} from "../contexts/authContext";
import { ActionProvider } from "./contexts/ActionContext";
import { HistoricAuditProvider } from "./contexts/HistoricAuditContext";
import { HistoricActionProvider } from "./contexts/HistoricActionContext";
import { CreateActionProvider } from "./contexts/CreateActionContext";
import { SiteSearchProvider } from "./contexts/SiteSearchContext";

function SafetynestIndex() {
  const dispatch = useAppDispatch();
  const { Track } = useTracking({
    app: trackingConstants.safetynestAppName,
  });
  const { user, isWorknestUser } = useAuth();
  const { selectedAccount } = useAppSelector(
    (state) => state.account
  );
  const userExternalId = user?.details?.userId;
  const accountExternalId = selectedAccount?.account?.externalId;

  useEffect(() => {
    dispatch(setActiveAppId(appIds.safetynest));
  }, [dispatch]);
  
  useEffect(() => {
    async function logUserLogin() {
      if (isWorknestUser)
        return;
      
      try {
        await userLoginLogService.addUserLoginLog({ accountExternalId, userExternalId });
      }
      catch(e) {
        console.error(e);
      }
    }
    
    logUserLogin();
  }, []);

  return (
    <Track>
      <IncidentProvider>
        <RiskAssessmentProvider>
          <ActionProvider>
           <SiteSearchProvider>
            <CreateActionProvider>
              <HistoricAuditProvider>
                <HistoricActionProvider>
                  {/* RouteMapper renders its own <Switch>/<Routes>; wrapping it
                      in another <Switch> puts a non-<Route> child directly under
                      RR7's <Routes>, which throws. */}
                  <RouteMapper routes={routes} />
                </HistoricActionProvider>
              </HistoricAuditProvider>
            </CreateActionProvider>
           </SiteSearchProvider>
          </ActionProvider>
        </RiskAssessmentProvider>
      </IncidentProvider>
    </Track>
  );
}

export default SafetynestIndex;
